import { Link } from "react-router-dom";
import { useState } from "react";
import { BRAND } from "../brand";

const HERO_IMAGES = [
  "/images/heroes/mm/hero-1.webp",
  "/images/heroes/mm/hero-2.webp",
  "/images/heroes/mm/hero-3.webp",
  "/images/heroes/mm/hero-4.webp",
  "/images/heroes/mm/hero-5.webp",
  "/images/heroes/mm/hero-6.webp",
  "/images/heroes/mm/hero-7.webp",
];

function randomHeroImage(): string {
  return HERO_IMAGES[Math.floor(Math.random() * HERO_IMAGES.length)] as string;
}

export default function CheckEmailPage() {
  const [heroImage] = useState(randomHeroImage);

  return (
    <div className="relative flex min-h-[70vh] items-center justify-center overflow-hidden rounded-xl">
      <div className="absolute inset-0 hidden lg:block">
        <img src={heroImage} alt={`${BRAND.name} training`} className="h-full w-full object-cover" data-testid="auth-hero-image" />
        <div className="absolute inset-0 bg-black/40" />
      </div>
      <div className="relative flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm space-y-8 rounded-xl border border-white/10 bg-gray-900/70 p-8 shadow-2xl backdrop-blur-lg dark:bg-gray-900/80">
          <div className="text-center">
            <div className="mb-6 flex items-center justify-center gap-2.5">
              <img src={BRAND.logoPath} alt={BRAND.name} className="h-9 w-9" />
              <span className="text-xl font-semibold tracking-tight text-white">{BRAND.name}</span>
            </div>
            <h1 className="text-2xl font-semibold text-white" data-testid="check-email-page-title">Check your email</h1>
            <p className="mt-2 text-sm text-gray-300">We've sent you a magic link. Click it to open your training journal.</p>
            <p className="mt-4 text-xs text-gray-400">
              Didn't receive it? Check your spam folder or <Link to="/login" className="font-medium text-emerald-400 hover:text-emerald-300" data-testid="check-email-retry-link">try again</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
